import { Notify } from "../notify";

export default () => ({
    loading: false,
    error: '',
    color: productColor,
    size: '',
    titles: {},
    stockOut: false,
    activeButton: false,

    form: {
        [':class']() {
            return this.loading ? 'disabled' : '';
        },

        ['@submit.prevent']() {
            this.submit();
        },

        ['@change']() {
            if(this.size !== '') {
                this.activeButton = true;
            }
        }
    },

    options: {
        ['@click']() {            
            const id = this.$el.getAttribute('for');
            const input = document.querySelector('#' + id);
            const name = input.name;
            const value = input.value;

            this.stockOut = false;
            this.titles[name] = this.$el.title;

            const items = document.querySelectorAll('input[name="' + name + '"]');

            for (const item of items) {
                item.classList.remove('disabled');
            }

            // const siblingName = name === 'color' ? 'size' : 'color'
            // const siblingItems = document.querySelectorAll('input[name="' + siblingName + '"]');

            // for (const item of siblingItems) {                
            //     let itemClass = item.classList;

            //     if (stock[name][value]['siblings'][item.value] !== undefined) {
            //         itemClass.remove('disabled');                    
            //     }
            //     else {
            //         itemClass.add('disabled');
            //         item.checked = false;
            //     }
            // }
        },
    },

    stockOutToggle() {
        const id = this.$el.getAttribute('for');
        const input = document.getElementById(id);

        if(input.classList.contains('disabled')) {
            this.stockOut = true;
        }
        else {
            this.stockOut = false;
        }
    },

    async submit() {
        this.loading = true;

        let form = this.$el;
        let formData = new FormData(form);
        formData.append('lang', lang);
        let response = await fetch('/api/cart/' + formData.get('productId'), {
            method: 'POST',
            headers: {
                'X-csrf-token': _token
            },
            body: formData,
        });

        if (!response.ok) {
            this.loading = false;
            return;
        }

        let result = await response.json();

        this.error = result.error;

        if (this.error !== '') {
            Notify.error(this.error);
        } else {
            this.$store.cart.load();

            Notify.success(result.success);
        }

        this.loading = false;
    }
})
